<template lang="pug">
	.categories
		router-link.categories__item(to="/diseases/" :class="{'categories__item_active': $route.name.toLowerCase() === 'diseases'}") Хвороби
		router-link.categories__item(to="/pests/" :class="{'categories__item_active': $route.name.toLowerCase() === 'pests'}") Шкідники
		router-link.categories__item(to="/weeds/" :class="{'categories__item_active': $route.name.toLowerCase() === 'weeds'}") Бур’яни
</template>

<script>

	export default {
		name: 'weedsCategories',
		data: function(){
			return {

			}
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';
	
	.categories {
		float: right;
		margin-top: 15px;

		&__item {
			display: inline-block;
			vertical-align: top;
			margin-left: 30px;
			opacity: .5;
			transition: opacity .5s ease;

			&_active {
				opacity: 1;
			}

			@media screen and (min-width: 1201px) {
				&:hover {
					opacity: .7;
					transition: opacity .3s ease;
				}
			}
		}

	}

	@media screen and (max-width: 1200px) {
		.categories {
			float: none;
			width: 100%;
			display: flex;
			justify-content: space-between;

			&__item {
				margin: 0;
				display: block;
			}
		}
	}

</style>